import { cn } from '../../utils/cn';
import type { CouponInputProps } from './coupon-input.types';
import styles from './coupon-input.module.css';
import type { HtmlElementStyles } from '../../../types/style';

export const couponStyles: HtmlElementStyles = {
    buttonContainerLabel: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
};

export const getCouponStyles = (variant: CouponInputProps['variant'], isCouponApplied: boolean) => {
    const rightButtonStyles = () => {
        if (variant === 'compact') {
            return {
                rightButton: cn(
                    styles.rightButton,
                    isCouponApplied ? styles.rightButtonWithAppliedCoupon : styles.rightButtonWithUnappliedCoupon
                ),
                couponText: cn(
                    styles.couponText,
                    isCouponApplied ? styles.couponTextWithAppliedCoupon : styles.couponTextWithUnappliedCoupon
                ),
            };
        }

        return {
            rightButton: cn(styles.rightButton, styles.rightButtonWithUnappliedCoupon),
            couponText: cn(styles.couponText, styles.couponTextWithUnappliedCoupon),
        };
    };

    return {
        rightButton: rightButtonStyles()?.rightButton,
        couponText: rightButtonStyles()?.couponText,
        inputContainer: cn(
            styles.inputContainer,
            isCouponApplied ? styles.inputContainerWithAppliedCoupon : styles.inputContainerWithUnappliedCoupon
        ),
        textInput: cn(
            styles.textInput,
            isCouponApplied ? styles.textInputWithAppliedCoupon : styles.textInputWithUnappliedCoupon
        ),
        buttonContainerLabel: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    };
};
